// NOVAPAY-116-R7A — shared legal/about footer: Back = one history step; never catalog via Back.
import type { StoreV2Lang } from "./store-v2-locale.js";
import { t } from "./store-v2-ui-copy.js";

export type LegalFooterDocNav = {
  onPrev?: () => void;
  onNext?: () => void;
  prevLabel?: string;
  nextLabel?: string;
};

export function LegalDetailFooterNav({
  lang,
  cartCount,
  onBack,
  onCart,
  onCatalog,
  docNav,
  onAllDocuments,
  testId = "sv2-legal-footer-nav",
}: {
  lang: StoreV2Lang;
  cartCount: number;
  /** Exactly one logical step back (hub / prior document / consent gate). Never catalog. */
  onBack: () => void;
  onCart?: () => void;
  onCatalog?: () => void;
  docNav?: LegalFooterDocNav;
  onAllDocuments?: () => void;
  testId?: string;
}) {
  const hasCart = cartCount > 0;
  const rightLabel = hasCart ? t(lang, "to_cart") : t(lang, "to_catalog");
  const onRight = hasCart ? onCart : onCatalog;

  return (
    <nav className="sv2-legal-footer-nav" data-testid={testId} aria-label={lang === "en" ? "Document navigation" : "Навігація документа"}>
      {docNav?.onPrev || docNav?.onNext ? (
        <div className="sv2-legal-footer-docs" data-testid="sv2-legal-footer-docs">
          {docNav.onPrev ? (
            <button type="button" className="sv2-cta sv2-secondary" data-testid="sv2-legal-doc-prev" onClick={docNav.onPrev}>
              {docNav.prevLabel ?? (lang === "en" ? "← Previous document" : "← Попередній документ")}
            </button>
          ) : (
            <span />
          )}
          {docNav.onNext ? (
            <button type="button" className="sv2-cta sv2-secondary" data-testid="sv2-legal-doc-next" onClick={docNav.onNext}>
              {docNav.nextLabel ?? (lang === "en" ? "Next document →" : "Наступний документ →")}
            </button>
          ) : (
            <span />
          )}
        </div>
      ) : null}
      {onAllDocuments ? (
        <button
          type="button"
          className="sv2-cta sv2-secondary sv2-legal-all-docs"
          data-testid="sv2-legal-all-documents"
          onClick={onAllDocuments}
        >
          {lang === "en" ? "All documents" : "Усі документи"}
        </button>
      ) : null}
      <div className="sv2-legal-footer-main">
        <button
          type="button"
          className="sv2-cta sv2-secondary"
          data-testid="sv2-legal-footer-back"
          onClick={onBack}
        >
          {lang === "en" ? "← Back" : "← Назад"}
        </button>
        {onRight ? (
          <button
            type="button"
            className="sv2-cta"
            data-testid={hasCart ? "sv2-legal-footer-cart" : "sv2-legal-footer-catalog"}
            onClick={onRight}
          >
            {rightLabel}
          </button>
        ) : null}
      </div>
    </nav>
  );
}
